import { render, staticRenderFns } from "./image.vue?vue&type=template&id=4894e53c"
import script from "./image.vue?vue&type=script&lang=js"
export * from "./image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4894e53c')) {
      api.createRecord('4894e53c', component.options)
    } else {
      api.reload('4894e53c', component.options)
    }
    module.hot.accept("./image.vue?vue&type=template&id=4894e53c", function () {
      api.rerender('4894e53c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/media-types/image.vue"
export default component.exports